import { Star } from 'lucide-react';
import { cn } from '@/lib/cn';
import { useT } from '@/lib/i18n/useT';

interface RatingPickerProps {
  value: number;
  onChange?: (next: number) => void;
  readOnly?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

export function RatingPicker({
  value,
  onChange,
  readOnly,
  size = 'md',
  className,
}: RatingPickerProps) {
  const t = useT();
  const dimension = size === 'sm' ? 'h-4 w-4' : 'h-5 w-5';
  return (
    <div className={cn('inline-flex items-center gap-1', className)}>
      {[1, 2, 3, 4, 5].map((n) => {
        const active = n <= value;
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            aria-label={n === 1 ? t('forms.rating.starOne') : `${n} ${t('forms.rating.starMany')}`}
            onClick={() => onChange?.(n)}
            className={cn(
              dimension,
              'rounded transition-colors disabled:cursor-default',
              !readOnly && 'hover:scale-110',
            )}
          >
            <Star
              className={cn(
                dimension,
                active
                  ? 'fill-[var(--color-accent)] text-[var(--color-accent)]'
                  : 'text-[var(--color-fg-subtle)]',
              )}
            />
          </button>
        );
      })}
    </div>
  );
}
